import { classnames } from '@/helpers';
import { ReactNode } from 'react';

const DataGridRow = ({
  children,
  hasPaddingTop,
  underline,
}: {
  children: ReactNode;
  hasPaddingTop?: boolean;
  underline?: boolean;
}) => {
  return (
    <div
      role="row"
      className={classnames(
        'pb-sm flex items-center justify-between',
        hasPaddingTop && 'pt-sm',
        underline && 'border-black-100 border-b',
      )}>
      {children}
    </div>
  );
};

export default DataGridRow;
